module.exports = __webpack_public_path__ + "img/metech_industrial.d9238839.png";